import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

import { DynamicContentHeaderType } from '../../enums/dynamicContentHeaderType.enum';
import { SectionContainer } from '../../uiComponents';
import { getLanguagePrefix, renderWhenTrue } from '../../utils';

import { ProductsSliderSectionData } from './productsSliderSection.types';
import {
  ProductBox,
  ProductHeader,
  Header,
  Description,
  ProductPhoto,
  LeftArrow,
  LeftArrowContainer,
  RightArrow,
  RightArrowContainer,
  SliderContainer,
  ComparisonSection,
} from './productsSliderSection.styled';
import ArrowIcon from './images/arrow.svg';

export const ProductsSliderSection: React.FC<ProductsSliderSectionData> = (data: ProductsSliderSectionData) => {
  const {
    header,
    description,
    products,
    className,
    boxesBaseUrl,
    currentLanguage,
  } = data;
  const [controlledSwiper, setControlledSwiper] = useState(null);
  const [isLeftArrowVisible, setIsLeftArrowVisible] = useState(false);
  const [isRightArrowVisible, setIsRightArrowVisible] = useState(products.length > 1);
  const [localComparisonData, setLocalComparisonData] = useState(JSON.parse(localStorage.getItem('comparisonData')) || []);

  const updateArrowsState = (event: any) => {
    if (event) {
      setIsLeftArrowVisible(!event.isBeginning && products.length > 1);
      setIsRightArrowVisible(!event.isEnd && products.length > 1);
    }
  };

  const goNext = () => {
    if (controlledSwiper) {
      controlledSwiper.slideNext();
    }
  };
 
  const goPrev = () => {
    if (controlledSwiper) {
      controlledSwiper.slidePrev();
    }
  };

  const renderLeftArrow = () => (
    <LeftArrowContainer isVisible={isLeftArrowVisible} onClick={goPrev}>
      <LeftArrow src={ArrowIcon} alt='left arrow' />
    </LeftArrowContainer>
  );

  const renderRightArrow = () => (
    <RightArrowContainer isVisible={isRightArrowVisible} onClick={goNext}>
      <RightArrow src={ArrowIcon} alt='right arrow' />
    </RightArrowContainer>
  );

  const renderSlider = (products) => (
    <SliderContainer>
      {renderLeftArrow()}
      <Swiper
        spaceBetween={5}
        slidesPerView='auto'
        onSwiper={setControlledSwiper}
        onTransitionEnd={updateArrowsState}
      >
        {renderProducts(products)}
      </Swiper>
      {renderRightArrow()}
    </SliderContainer>
  );

  const isProductInComparison = (pageId) => {
    const comparisonData = JSON.parse(localStorage.getItem('comparisonData')) || [];
    return comparisonData.includes(pageId);
  };

  const sendEvent = () => {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('storage:update', true, true);
    document.dispatchEvent(event);
  }

  document.addEventListener('storage:update', (event) => {
    const comparisonData = JSON.parse(localStorage.getItem('comparisonData')) || [];
    setLocalComparisonData(comparisonData);
  });

  const toogleProductInComparison = (pageId) => {
    const comparisonData = JSON.parse(localStorage.getItem('comparisonData')) || [];
    setLocalComparisonData(comparisonData);
    if (comparisonData.length < 3 && !isProductInComparison(pageId)) {
      comparisonData.push(pageId);
      localStorage.setItem('comparisonData', JSON.stringify(comparisonData));
      localStorage.setItem('comparisonDataLangKey', currentLanguage);
      sendEvent();
    } else if (isProductInComparison(pageId)) {
      comparisonData.splice(comparisonData.indexOf(pageId), 1);
      localStorage.setItem('comparisonData', JSON.stringify(comparisonData));
      localStorage.setItem('comparisonDataLangKey', currentLanguage);
      sendEvent();
    }
  };

  const filterProducts = (productList) => productList.filter(
    (product) => {
      return !!product.acf.productContent.find(
        (productContentItem) => !!(productContentItem.dynamicContent && productContentItem.dynamicContent.find(
          (dynamicContentItem) => dynamicContentItem.acf_fc_layout == 'tableWithButton'
        ))
      )
    }
  );

  const renderProducts = (productList) => filterProducts(productList).map((product) => {
    const productContentWithSettings =  product.acf.productContent.find(
      (productContentItem) => !!(productContentItem.dynamicContent && productContentItem.dynamicContent.find(
        (dynamicContentItem) => dynamicContentItem.acf_fc_layout == 'tableWithButton'
      ))
    );
    const productContentWithSettings2 =  productContentWithSettings.dynamicContent.find(
        (dynamicContentItem) => dynamicContentItem.acf_fc_layout == 'tableWithButton'
    );
    const { removeButtonLabel, addButtonLabel } = productContentWithSettings2.tableWithButton.comparisonButtonSettings;
    const { subheader, productImages } = product.acf.productHeaderSection;
    const { label, value } = subheader;
    const renderProductPhoto = renderWhenTrue(() => (
      <ProductPhoto src={productImages[0]?.localFile?.url} alt='' />
    ));
    const renderComparisonSection = renderWhenTrue(() => (
      <ComparisonSection
        disabled={!isProductInComparison(product.post_name) && localComparisonData.length === 3}
        onClick={() => toogleProductInComparison(product.post_name)}
      >
        {isProductInComparison(product.post_name) ? removeButtonLabel : addButtonLabel}
      </ComparisonSection>
    ));
    const getLinkBoxUrl = () => boxesBaseUrl
      ? `/${getLanguagePrefix(currentLanguage)}${boxesBaseUrl}/${product.post_name}`
      : product.post_name;

    return (
      <SwiperSlide key={product.post_title}>
        <ProductBox>
          <Link
            to={getLinkBoxUrl()}
          >
            <ProductHeader>
              <Header>{product.post_title}</Header>
              <Description>{label} {value}</Description>
            </ProductHeader>
            {renderProductPhoto(!!productImages)}
          </Link>
          {renderComparisonSection(!!localComparisonData)}
        </ProductBox>
      </SwiperSlide>
    );
  });

  return (
    <SectionContainer
      header={header}
      subheader={description}
      headerType={DynamicContentHeaderType.BigTextHeader}
      className={className}
      spaceBetween='100px'
    >
      {renderSlider(products)}
    </SectionContainer>
  );
};
